import * as mutation from "./mutation-types";
import * as systemMutation from "@/store/system/mutation-types";
import * as action from "./action-types";
import { deepCopyAxiosException } from "@/store/helpers";
import axios from "axios";
import { Promise } from "core-js";

export const actions = {
  async [action.LOAD_STATIC_LOOKUPS]({ commit }) {
    commit(mutation.LOAD_STATIC_LOOKUPS_STARTED);
    try {
      const { data } = await axios.get("/api/lookups/static");
      commit(mutation.LOAD_STATIC_LOOKUPS_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.LOAD_STATIC_LOOKUPS_FAILED);
      commit(systemMutation.GLOBAL_ERROR_FATAL, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.LOAD_DYNAMIC_LOOKUPS]({ commit }) {
    commit(mutation.LOAD_DYNAMIC_LOOKUPS_STARTED);
    try {
      let allLevyCollections, currentLevyCollections, roleCodes;
      [allLevyCollections, currentLevyCollections, roleCodes] = await Promise.all([
        axios.get("/api/lookups/all-levy-collections"),
        axios.get("/api/lookups/current-levy-collections"),
        axios.get("/api/lookups/role-codes")
      ]);
      commit(mutation.LOAD_DYNAMIC_LOOKUPS_SUCCEEDED, {
        allLevyCollections: allLevyCollections.data,
        currentLevyCollections: currentLevyCollections.data,
        roleCodes: roleCodes.data
      });
      return true;
    } catch (e) {
      commit(mutation.LOAD_DYNAMIC_LOOKUPS_FAILED);
      commit(systemMutation.GLOBAL_ERROR_FATAL, deepCopyAxiosException(e));
      return false;
    }
  }
};
